import * as axiosLib from 'axios';
import environment from '../environments/environment';
import { AuthService } from '../services/auth-service';

export type RawAxiosHeaders = Record<string, axiosLib.AxiosHeaderValue | axiosLib.AxiosHeaders>;

const axios = axiosLib.default.create({
  baseURL: environment.api.url,
});

axios.interceptors.request.use(
  (request) => {
    const authToken = AuthService.getAuthToken() || AuthService.getTestingDashboardAuthToken();
    if (authToken) {
      request.headers.Authorization = authToken;
    }
    return request;
  },
  (error) => Promise.reject(error),
);

export { axios };
